import { Link } from 'react-router-dom';

const footerLinks = [
  {
    title: '热门分类',
    items: [
      { label: '今日大瓜', path: '/category/jin-ri-da-gua' },
      { label: '网红塌房', path: '/category/wang-hong-ta-fang' },
      { label: '明星擦边', path: '/category/ming-xing-ca-bian' },
      { label: '娱乐圈潜规则', path: '/category/yule-quan-qian-gui-ze' },
    ],
  },
  {
    title: '经典回顾',
    items: [
      { label: '历年大瓜合集', path: '/category/li-nian-he-ji' },
      { label: '直播翻车现场', path: '/category/zhi-bo-fan-che' },
      { label: '独家爆料', path: '/' },
    ],
  },
  {
    title: '关于我们',
    items: [
      { label: '品牌介绍', path: '/about' },
      { label: '联系方式', path: '/about' },
      { label: '投稿爆料', path: '/about' },
    ],
  },
  {
    title: '友情链接',
    items: [
      { label: '51黑料吃瓜网', path: '/' },
      { label: '吃瓜社区', path: '/' },
      { label: '八卦论坛', path: '/' },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="bg-secondary-950 text-background-50">
      <div className="absolute inset-0 opacity-5 pointer-events-none" style={{
        backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='1'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`,
      }} />

      <div className="relative max-w-7xl mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 lg:grid-cols-5 gap-10">
          <div className="lg:col-span-2">
            <Link to="/" className="inline-flex items-center gap-2 mb-4">
              <span className="text-2xl font-heading font-bold text-background-50">
                黑料六点半
              </span>
              <span className="w-2 h-2 rounded-full bg-accent-500"></span>
            </Link>
            <p className="text-foreground-400 text-sm leading-relaxed mb-6 max-w-sm">
              24小时实时追踪娱乐圈潜规则、网红塌房与明星擦边黑料。
              吃瓜无罪，八卦有理——你的专属娱乐圈情报站。
            </p>
            <div className="flex items-center gap-3">
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg border border-foreground-500/30 text-foreground-400 hover:text-background-50 hover:border-background-50/60 transition-all duration-200" aria-label="微博">
                <i className="ri-weibo-line text-lg"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg border border-foreground-500/30 text-foreground-400 hover:text-background-50 hover:border-background-50/60 transition-all duration-200" aria-label="微信">
                <i className="ri-wechat-line text-lg"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg border border-foreground-500/30 text-foreground-400 hover:text-background-50 hover:border-background-50/60 transition-all duration-200" aria-label="抖音">
                <i className="ri-tiktok-line text-lg"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg border border-foreground-500/30 text-foreground-400 hover:text-background-50 hover:border-background-50/60 transition-all duration-200" aria-label="B站">
                <i className="ri-bilibili-line text-lg"></i>
              </a>
            </div>
          </div>

          {footerLinks.map((group) => (
            <div key={group.title}>
              <h4 className="text-sm font-semibold text-background-50 mb-4">{group.title}</h4>
              <ul className="space-y-2.5">
                {group.items.map((item) => (
                  <li key={item.label}>
                    <Link
                      to={item.path}
                      className="text-sm text-foreground-400 hover:text-background-50 transition-colors duration-200"
                    >
                      {item.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-12 pt-8 border-t border-foreground-500/15 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-500">
            &copy; 2026 黑料六点半. 保留所有权利.
          </p>
          <div className="flex items-center gap-6">
            <a href="#" className="text-xs text-foreground-500 hover:text-background-50 transition-colors">隐私政策</a>
            <a href="#" className="text-xs text-foreground-500 hover:text-background-50 transition-colors">用户协议</a>
            <a href="#" className="text-xs text-foreground-500 hover:text-background-50 transition-colors">免责声明</a>
          </div>
        </div>
      </div>
    </footer>
  );
}